import { render, staticRenderFns } from "./VScroller.vue?vue&type=template&id=aedd1fbc&scoped=true&"
import script from "./VScroller.vue?vue&type=script&lang=tsx&"
export * from "./VScroller.vue?vue&type=script&lang=tsx&"
import style0 from "./VScroller.vue?vue&type=style&index=0&id=aedd1fbc&scoped=true&lang=css&"
import style1 from "./VScroller.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedd1fbc",
  null
  
)

export default component.exports